import { cn } from '../cn';

export interface SkeletonProps {
  className?: string;
  /** Atalho pra blocos retangulares: altura via Tailwind (ex: 'h-4 w-32'). */
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}

/**
 * Placeholder de carregamento (pulse). Funciona em superfícies claras (admin) e
 * escuras (trader) — usa `bg-current` com baixa opacidade, então herda a cor do
 * texto do container. Combine classes de tamanho via `className`.
 */
export function Skeleton({ className, rounded = 'md' }: SkeletonProps) {
  const r =
    rounded === 'full'
      ? 'rounded-full'
      : rounded === 'lg'
        ? 'rounded-lg'
        : rounded === 'sm'
          ? 'rounded'
          : 'rounded-md';
  return <div className={cn('bg-current/10 animate-pulse', r, className)} aria-hidden="true" />;
}

/** Cartão de skeleton genérico pra blocos do dashboard/listas. */
export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div
      className={cn('border-current/10 space-y-3 rounded-2xl border p-5', className)}
      aria-hidden="true"
    >
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-8 w-2/3" />
      <Skeleton className="h-24 w-full" rounded="lg" />
    </div>
  );
}
